import type { U3204DisplayMessage, U3204ExportFile } from '../U3204Service';

const U3204_EXPORT_ATTACHMENT_TYPES = new Set(['excel', 'word', 'pdf_export']);

const U3204_MIME_EXCEL =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const U3204_MIME_WORD =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const U3204_MIME_PDF = 'application/pdf';

function u3204InferExportMimeFromFileName(fileName: string): string {
  const name = fileName.toLowerCase();
  if (name.endsWith('.docx')) {
    return U3204_MIME_WORD;
  }
  if (name.endsWith('.pdf')) {
    return U3204_MIME_PDF;
  }
  return U3204_MIME_EXCEL;
}

function u3204DefaultExportMime(attachmentType: string): string {
  if (attachmentType === 'word') {
    return U3204_MIME_WORD;
  }
  if (attachmentType === 'pdf_export') {
    return U3204_MIME_PDF;
  }
  return U3204_MIME_EXCEL;
}

/**
 * Résout le fichier export (Excel, Word ou PDF) à afficher
 * (exportFile API ou attachment excel|word|pdf_export — pas les PJ upload `pdf`).
 */
export function u3204ResolveExportFile(message: U3204DisplayMessage): U3204ExportFile | null {
  if (message.exportFile?.fileUrl && message.exportFile.fileName) {
    return {
      fileUrl: message.exportFile.fileUrl,
      fileName: message.exportFile.fileName,
      fileMimeType:
        message.exportFile.fileMimeType ||
        u3204InferExportMimeFromFileName(message.exportFile.fileName),
    };
  }

  const exportAtt = message.attachments?.find(
    (att) =>
      U3204_EXPORT_ATTACHMENT_TYPES.has(att.attachmentType) &&
      typeof att.fileUrl === 'string' &&
      att.fileUrl.length > 0,
  );
  if (!exportAtt?.fileUrl) {
    return null;
  }

  return {
    fileUrl: exportAtt.fileUrl,
    fileName: exportAtt.fileName,
    fileMimeType: exportAtt.mimeType || u3204DefaultExportMime(exportAtt.attachmentType),
  };
}
